import { Table } from "../../../../../../components/Functional";
import { Button, Modal } from "../../../../../../components/ui";
import { FETCH_FABRICATIONS_V2 } from "../../../../../../graphql/query/Fabrication";
import SectionHeader from "../../components/SectionHeader";
import Actions from "./components/Actions";
import AddCost from "./components/AddCost";

const Costs = props => {
  const { invoiceId } = props;
  const tableProps = {
    variant: "dynamicHeight",
    dataKey: "fabricationsV2",
    headers: [
      { label: "Date", name: "date", type: "date" },
      { label: "Type", name: "type.description", type: "label" },
      { label: "Purchase Order #", name: "po", type: "label" },
      { label: "Description", name: "description", type: "label" },
      { label: "Currency", name: "currency.code", type: "label" },
      { label: "Net Amount", name: "amount", type: "label" },
      { label: "Recharge Amount", name: "recharge", type: "label" },
      { label: "Recharge Rate", name: "rechargerate", type: "label" },
      { label: "Allocation", name: "instance.name", type: "label" },
      {
        label: "",
        name: "actions",
        type: "custom",
        component: Actions,
        invoiceId,
      },
    ],
    FETCH_QUERY: FETCH_FABRICATIONS_V2({
      currency: {},
      type: {},
      instance: {},
      invoice: true,
    }),
    variables: {
      invoiceId,
    },
  };

  const modalProps = {
    body: AddCost,
    invoiceId,
    hideCloseButton: true,
    scale: "md",
  };

  const costActions = [
    {
      type: "black",
      component: () => (
        <Modal {...modalProps}>
          <Button label="Add Cost" />
        </Modal>
      ),
    },
  ];

  return (
    <div className="w-full">
      <SectionHeader title="Costs" actions={costActions} />
      <div className="mb-6 w-full">
        <Table {...tableProps} />
      </div>
    </div>
  );
};

export default Costs;
